export default __webpack_public_path__ + "static/INSTAR_Cloud_Alexa_Skill_08-EN-aa9a3c970c2ed1b71ac1e772e5768845.webp";